import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import React, { useEffect } from 'react'
import Api from "../../services/Api";
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { arrowForward } from 'ionicons/icons';

const MyNetworks = () => {
  const api = Api.getInstance()
  const teams = useSelector((state: RootState) => state.logIn.user.teams)

  useEffect(() => {
    console.log(teams)
  })
  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
          <IonTitle>My networks</IonTitle>
          <IonButtons slot="end">
            <IonButton 
              routerLink='/walk/networks/explore'
              size="small" 
              color="primary"   
              fill='solid'>
              Explore networks
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          {teams.map((team: any, index: any) => (
            <IonItem routerLink={'/walk/team/' + team.teamKey}>
              <IonLabel>
                {team.teamName}
              </IonLabel>
              <IonIcon icon={arrowForward} slot="end" />
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonPage>
  )
}
export default MyNetworks